// SWR hook for the warehouse selector dropdown. Backed by the existing
// /ord/order/backorder/warehouse/select endpoint scoped to the current
// business. Server returns up to 50 warehouses; debounce on the consumer
// side via the optional `query` argument.

import useSWR from "swr";
import { DeliveryApi } from "../../../apis";

interface IWarehouseRow {
  id: string;
  name: string;
  isDefault?: boolean;
  warehouseUser?: { firstName?: string; lastName?: string };
}

export const useWarehouseOptions = (businessId: string | null | undefined, query?: string | null) => {
  const { data, isLoading, error } = useSWR(
    businessId ? ["delivery.warehouse-select", businessId, query ?? ""] : null,
    async () => {
      const res = await DeliveryApi.warehouseSelect({
        businessId: businessId as string,
        query     : query ?? null,
        limit     : 50,
      });
      return res as IWarehouseRow[];
    },
    { revalidateOnFocus: false },
  );

  return {
    warehouses: (data ?? []) as IWarehouseRow[],
    isLoading,
    error,
  };
};
